import {Component} from 'react';
import axios from "axios"
import myconfig from "../myconfig";
import Swal from "sweetalert2";
import logimg from "../img/ZTSlogo.PNG";

let source = axios.CancelToken.source();

class Nav extends Component {
    constructor() {
        super();

        this.state = {
            matrix: [],
            martixload: false,

            maindashboard: 'nav-item',
            maindashboard1: 'nav-link',
            dashboard1: 'nav-link',
            dashboard2: 'nav-link',
            dashboard3: 'nav-link',
            dashboard4: 'nav-link',
            dashboard5: 'nav-link',
            dashboard_status: 'nav-link',

            usermgt: 'nav-item',
            usermgt1: 'nav-link',
            user: 'nav-link',
            objuser: 'nav-link',
            useraccess1: 'nav-link',

            ordermgt: 'nav-item',
            ordermgt1: 'nav-link',
            order: 'nav-link',
            order_change_date: 'nav-link',
            order_change_cargo: 'nav-link',
            order_change_volume: 'nav-link',
            order_change_sale_type: 'nav-link',

            allocatemgt: 'nav-item',
            allocatemgt1: 'nav-link',
            allocate_allocate_vehicle: 'nav-link',
            allocate_unallocate_vehicle: 'nav-link',
            allocate_date: 'nav-link',
            allocate_cost_manage: 'nav-link',
            allocate_cost_approval: 'nav-link',
            allocate_cost_report: 'nav-link',
            allocate_weight: 'nav-link',
            allocate_unload: 'nav-link',
            allocate_change_route: 'nav-link',
            allocate_finance: 'nav-link',
            allocate_allocate_vehicle_v2: 'nav-link',
            allocate_cost_mgt_v2: 'nav-link',
            allocate_cost_approve_v2: 'nav-link',
            allocate_cost_approve_v3: 'nav-link',
            allocate_allocate_vehicle_v3: 'nav-link',


            allocateextendmgt: 'nav-item',
            allocateextendmgt1: 'nav-link',
            allocate_extend_trip_req: 'nav-link',
            allocate_extend_trip_approval: 'nav-link',
            allocate_extend_trip_report: 'nav-link',


            adminmenumgt: 'nav-item',
            adminmenumgt1: 'nav-link',
            admin_transport: 'nav-link',
            admin_vehicle: 'nav-link',
            admin_driver: 'nav-link',
            admin_trailer: 'nav-link',
            admin_assignement: 'nav-link',
            admin_location: 'nav-link',
            admin_road_route: 'nav-link',
            admin_cargo: 'nav-link',
            admin_status: 'nav-link',

            followupmenumgt: 'nav-item',
            followupmenumgt1: 'nav-link',
            follow_up_allocated_veh: 'nav-link',
            follow_up_to_load_veh: 'nav-link',
            follow_up_load_veh: 'nav-link',
            follow_up_departure_veh: 'nav-link',
            follow_up_to_unload_veh: 'nav-link',
            follow_up_unload_veh: 'nav-link',
            follow_up_status: 'nav-link',
            follow_up_status_v2: 'nav-link',
            follow_up_finish: 'nav-link',
            follow_up_v2: 'nav-link',
            follow_up_contoral: 'nav-link',

            orderstatusmgt: 'nav-item',
            orderstatusmgt1: 'nav-link',
            open_order_status: 'nav-link',
            close_order_status: 'nav-link',
            allocation_status: 'nav-link',
            movement_status: 'nav-link',

            reportmgt: 'nav-item',
            reportmgt1: 'nav-link',
            rep_tracking_master: 'nav-link',
            rep_tac: 'nav-link',
            rep_trip_master: 'nav-link',
            master_trip_2: 'nav-link',
            screen_1: 'nav-link',
            screen_2: 'nav-link',
            customer_tracking: 'nav-link',

            driver_pointmgt: 'nav-item',
            driver_pointmgt1: 'nav-link',
            driver_point_by_trip: 'nav-link',
            driver_point_by_vio: 'nav-link',
        }
    }
    fetcheduseraccess = () => {
        let baseurl = myconfig.getuasession;
        let sid = window.localStorage.getItem("ntfms_sid")
        axios.post(baseurl, {
            sid: sid,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(myconfig.redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                console.log(res.data.datas)
                this.setState({
                    matrix: res.data.datas,
                    martixload: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    componentDidMount() {
        this.fetcheduseraccess();
        if (this.props.type == "dashboard1") {
            this.setState(
                {
                    maindashboard: 'nav-item menu-open active',
                    maindashboard1: 'nav-link active',
                    dashboard1: 'nav-link active',
                }
            );
        } else if (this.props.type == "dashboard2") {
            this.setState(
                {
                    maindashboard: 'nav-item menu-open active',
                    maindashboard1: 'nav-link active',
                    dashboard2: 'nav-link active',
                }
            );
        } else if (this.props.type == "dashboard3") {
            this.setState(
                {
                    maindashboard: 'nav-item menu-open active',
                    maindashboard1: 'nav-link active',
                    dashboard3: 'nav-link active',
                }
            );
        }else if (this.props.type == "dashboard4") {
            this.setState(
                {
                    maindashboard: 'nav-item menu-open active',
                    maindashboard1: 'nav-link active',
                    dashboard4: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "dashboard5") {
            this.setState(
                {
                    maindashboard: 'nav-item menu-open active',
                    maindashboard1: 'nav-link active',
                    dashboard5: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "dashboard_status") {
            this.setState(
                {
                    maindashboard: 'nav-item menu-open active',
                    maindashboard1: 'nav-link active',
                    dashboard_status: 'nav-link active',
                }
            );
        } else if (this.props.type == "user") {
            this.setState(
                {
                    usermgt: 'nav-item menu-open active',
                    usermgt1: 'nav-link active',
                    user: 'nav-link active',
                }
            );
        } else if (this.props.type == "objuser") {
            this.setState(
                {
                    usermgt: 'nav-item menu-open active',
                    usermgt1: 'nav-link active',
                    objuser: 'nav-link active',
                }
            );
        } else if (this.props.type == "useraccess1") {
            this.setState(
                {
                    usermgt: 'nav-item menu-open active',
                    usermgt1: 'nav-link active',
                    useraccess1: 'nav-link active',
                }
            );
        } else if (this.props.type == "order") {
            this.setState(
                {
                    ordermgt: 'nav-item menu-open active',
                    ordermgt1: 'nav-link active',
                    order: 'nav-link active',
                }
            );
        } else if (this.props.type == "order_change_date") {
            this.setState(
                {
                    ordermgt: 'nav-item menu-open active',
                    ordermgt1: 'nav-link active',
                    order_change_date: 'nav-link active',
                }
            );
        } else if (this.props.type == "order_change_cargo") {
            this.setState(
                {
                    ordermgt: 'nav-item menu-open active',
                    ordermgt1: 'nav-link active',
                    order_change_cargo: 'nav-link active',
                }
            );
        } else if (this.props.type == "order_change_volume") {
            this.setState(
                {
                    ordermgt: 'nav-item menu-open active',
                    ordermgt1: 'nav-link active',
                    order_change_volume: 'nav-link active',
                }
            );
        } else if (this.props.type == "order_change_sale_type") {
            this.setState(
                {
                    ordermgt: 'nav-item menu-open active',
                    ordermgt1: 'nav-link active',
                    order_change_sale_type: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_allocate_vehicle") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_allocate_vehicle: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_unallocate_vehicle") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_unallocate_vehicle: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_date") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_date: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_cost_manage") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_cost_manage: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_cost_approval") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_cost_approval: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_cost_report") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_cost_report: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_weight") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_weight: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_unload") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_unload: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "allocate_change_route") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_change_route: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "allocate_finance") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_finance: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "allocate_allocate_vehicle_v2") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_allocate_vehicle_v2: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "allocate_cost_mgt_v2") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_cost_mgt_v2: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "allocate_cost_approve_v2") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_cost_approve_v2: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "allocate_cost_approve_v3") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_cost_approve_v3: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "allocate_allocate_vehicle_v3") {
            this.setState(
                {
                    allocatemgt: 'nav-item menu-open active',
                    allocatemgt1: 'nav-link active',
                    allocate_allocate_vehicle_v3: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_extend_trip_req") {
            this.setState(
                {
                    allocateextendmgt: 'nav-item menu-open active',
                    allocateextendmgt1: 'nav-link active',
                    allocate_extend_trip_req: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_extend_trip_approval") {
            this.setState(
                {
                    allocateextendmgt: 'nav-item menu-open active',
                    allocateextendmgt1: 'nav-link active',
                    allocate_extend_trip_approval: 'nav-link active',
                }
            );
        } else if (this.props.type == "allocate_extend_trip_report") {
            this.setState(
                {
                    allocateextendmgt: 'nav-item menu-open active',
                    allocateextendmgt1: 'nav-link active',
                    allocate_extend_trip_report: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "admin_transport") {
            this.setState(
                {
                    adminmenumgt: 'nav-item menu-open active',
                    adminmenumgt1: 'nav-link active',
                    admin_transport: 'nav-link active',
                }
            );
        } else if (this.props.type == "admin_vehicle") {
            this.setState(
                {
                    adminmenumgt: 'nav-item menu-open active',
                    adminmenumgt1: 'nav-link active',
                    admin_vehicle: 'nav-link active',
                }
            );
        } else if (this.props.type == "admin_driver") {
            this.setState(
                {
                    adminmenumgt: 'nav-item menu-open active',
                    adminmenumgt1: 'nav-link active',
                    admin_driver: 'nav-link active',
                }
            );
        } else if (this.props.type == "admin_trailer") {
            this.setState(
                {
                    adminmenumgt: 'nav-item menu-open active',
                    adminmenumgt1: 'nav-link active',
                    admin_trailer: 'nav-link active',
                }
            );
        } else if (this.props.type == "admin_assignement") {
            this.setState(
                {
                    adminmenumgt: 'nav-item menu-open active',
                    adminmenumgt1: 'nav-link active',
                    admin_assignement: 'nav-link active',
                }
            );
        } else if (this.props.type == "admin_location") {
            this.setState(
                {
                    adminmenumgt: 'nav-item menu-open active',
                    adminmenumgt1: 'nav-link active',
                    admin_location: 'nav-link active',
                }
            );
        } else if (this.props.type == "admin_road_route") {
            this.setState(
                {
                    adminmenumgt: 'nav-item menu-open active',
                    adminmenumgt1: 'nav-link active',
                    admin_road_route: 'nav-link active',
                }
            );
        } else if (this.props.type == "admin_cargo") {
            this.setState(
                {
                    adminmenumgt: 'nav-item menu-open active',
                    adminmenumgt1: 'nav-link active',
                    admin_cargo: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "admin_status") {
            this.setState(
                {
                    adminmenumgt: 'nav-item menu-open active',
                    adminmenumgt1: 'nav-link active',
                    admin_status: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_allocated_veh") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_allocated_veh: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_to_load_veh") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_to_load_veh: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_load_veh") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_load_veh: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_departure_veh") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_departure_veh: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_to_unload_veh") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_to_unload_veh: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_unload_veh") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_unload_veh: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_status") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_status: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_status_v2") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_status_v2: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_finish") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_finish: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_v2") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_v2: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "follow_up_contoral") {
            this.setState(
                {
                    followupmenumgt: 'nav-item menu-open active',
                    followupmenumgt1: 'nav-link active',
                    follow_up_contoral: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "open_order_status") {
            this.setState(
                {
                    orderstatusmgt: 'nav-item menu-open active',
                    orderstatusmgt1: 'nav-link active',
                    open_order_status: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "close_order_status") {
            this.setState(
                {
                    orderstatusmgt: 'nav-item menu-open active',
                    orderstatusmgt1: 'nav-link active',
                    close_order_status: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "allocation_status") {
            this.setState(
                {
                    orderstatusmgt: 'nav-item menu-open active',
                    orderstatusmgt1: 'nav-link active',
                    allocation_status: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "movement_status") {
            this.setState(
                {
                    orderstatusmgt: 'nav-item menu-open active',
                    orderstatusmgt1: 'nav-link active',
                    movement_status: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "rep_tracking_master") {
            this.setState(
                {
                    reportmgt: 'nav-item menu-open active',
                    reportmgt1: 'nav-link active',
                    rep_tracking_master: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "rep_tac") {
            this.setState(
                {
                    reportmgt: 'nav-item menu-open active',
                    reportmgt1: 'nav-link active',
                    rep_tac: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "rep_trip_master") {
            this.setState(
                {
                    reportmgt: 'nav-item menu-open active',
                    reportmgt1: 'nav-link active',
                    rep_trip_master: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "master_trip_2") {
            this.setState(
                {
                    reportmgt: 'nav-item menu-open active',
                    reportmgt1: 'nav-link active',
                    master_trip_2: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "screen_1") {
            this.setState(
                {
                    reportmgt: 'nav-item menu-open active',
                    reportmgt1: 'nav-link active',
                    screen_1: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "screen_2") {
            this.setState(
                {
                    reportmgt: 'nav-item menu-open active',
                    reportmgt1: 'nav-link active',
                    screen_2: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "customer_tracking") {
            this.setState(
                {
                    reportmgt: 'nav-item menu-open active',
                    reportmgt1: 'nav-link active',
                    customer_tracking: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "driver_point_by_trip") {
            this.setState(
                {
                    driver_pointmgt: 'nav-item menu-open active',
                    driver_pointmgt1: 'nav-link active',
                    driver_point_by_trip: 'nav-link active',
                }
            );
        }
        else if (this.props.type == "driver_point_by_vio") {
            this.setState(
                {
                    driver_pointmgt: 'nav-item menu-open active',
                    driver_pointmgt1: 'nav-link active',
                    driver_point_by_vio: 'nav-link active',
                }
            );
        }
    }

    logout = (event) => {
        event.preventDefault();
        let baseurl = myconfig.logout
        axios.post(baseurl, {
            'sid': window.localStorage.getItem("ntfms_sid"),
        }, {cancelToken: source.token}).then(res => {
        }).catch((e) => {
            console.log(e.message);
        });
        window.localStorage.setItem("ntfms_sid", null);
        window.localStorage.setItem("ntfms_username", null);
        window.localStorage.setItem("ntfms_name", null);
        var win = window.open(myconfig.redirecttologin, "_self");
    }
    displaymenus = () => {
        if (this.state.martixload) {
            let dashboard1 = "";
            let dashboard2 = "";
            let dashboard3 = "";
            let dashboard4 = "";
            let dashboard5 = "";
            let dashboard_status = "";
            let dashboardmenu = "";
            let maindashboardmgt = this.state.matrix.filter(value => {
                if (value.object_name == "dashboard1" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    dashboard1 =
                        <a href={myconfig.urldashboard1} className={this.state.dashboard1}><i
                            className="far fa-circle nav-icon"/>
                            <p>Vehicle Status</p>
                        </a>
                    return value;
                }
                if (value.object_name == "dashboard2" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    dashboard2 =
                        <a href={myconfig.urldashboard2} className={this.state.dashboard2}><i
                            className="far fa-circle nav-icon"/>
                            <p>Finance</p>
                        </a>
                    return value;
                }
                if (value.object_name == "dashboard3" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    dashboard3 =
                        <a href={myconfig.urldashboard3} className={this.state.dashboard3}><i
                            className="far fa-circle nav-icon"/>
                            <p>Driver Performance</p>
                        </a>
                    return value;
                }
                if (value.object_name == "dashboard4" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    dashboard4 =
                        <a href={myconfig.urldashboard4} className={this.state.dashboard4}><i
                            className="far fa-circle nav-icon"/>
                            <p>Location Status</p>
                        </a>
                    return value;
                }
                if (value.object_name == "dashboard5" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    dashboard5 =
                        <a href={myconfig.urldashboard5} className={this.state.dashboard5}><i
                            className="far fa-circle nav-icon"/>
                            <p>Planning-1</p>
                        </a>
                    return value;
                }
                if (value.object_name == "dashboard_status" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    dashboard_status =
                        <a href={myconfig.urldashboard_status} className={this.state.dashboard_status}><i
                            className="far fa-circle nav-icon"/>
                            <p>Planning-2</p>
                        </a>
                    return value;
                }
            })
            if (maindashboardmgt.length > 0) {
                dashboardmenu =
                    <li name="stock" onClick={(event => {
                        this.menuclick(event, this.state.maindashboard)
                    })} className={this.state.maindashboard}>
                        <a href="#" name="stock" onClick={(event => {
                            this.menuclick(event, this.state.maindashboard)
                        })} className={this.state.maindashboard1}>
                            <i className="nav-icon fas fa-tachometer-alt"/>
                            <p>
                                Dashboard
                                <i className="right fas fa-angle-left"/>
                            </p>
                        </a>
                        <ul className="nav nav-treeview">
                            <li className="nav-item">
                                {dashboard1}
                                {dashboard2}
                                {dashboard3}
                                {dashboard4}
                                {dashboard5}
                                {dashboard_status}
                            </li>
                        </ul>
                    </li>
            }

            let user = "";
            let objuser = "";
            let useraccess1 = "";
            let usermenu = "";
            let usermgt = this.state.matrix.filter(value => {
                if (value.object_name == "user" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    user =
                        <a href={myconfig.urluser} className={this.state.user}><i className="far fa-circle nav-icon"/>
                            <p>User</p></a>
                    return value;
                }
                if (value.object_name == "objuser" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    objuser =
                        <a href={myconfig.urlobjuser} className={this.state.objuser}><i
                            className="far fa-circle nav-icon"/>
                            <p>User Object</p></a>
                    return value;
                }
                if (value.object_name == "useraccess1" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    useraccess1 =
                        <a href={myconfig.urluseraccess1} className={this.state.useraccess1}><i
                            className="far fa-circle nav-icon"/>
                            <p>User Access</p></a>
                    return value;
                }
            })
            if (usermgt.length > 0) {
                usermenu = <li name="usermgt" onClick={(event => {
                    this.menuclick(event, this.state.usermgt)
                })} className={this.state.usermgt}>
                    <a name="usermgt" onClick={(event => {
                        this.menuclick(event, this.state.usermgt)
                    })} href="#" className={this.state.usermgt1}>
                        <i className="nav-icon fas fa-user"/>
                        <p>
                            User Managment
                            <i className="right fas fa-angle-left"/>
                        </p>
                    </a>
                    <ul className="nav nav-treeview">
                        <li className="nav-item">
                            {user}
                            {objuser}
                            {useraccess1}
                        </li>
                    </ul>
                </li>
            }

            let order = "";
            let order_change_date = "";
            let order_change_cargo = "";
            let order_change_volume = "";
            let order_change_sale_type = "";
            let ordermenu = "";
            let ordermgt = this.state.matrix.filter(value => {
                if (value.object_name == "order" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    order =
                        <a href={myconfig.urlorder} className={this.state.order}><i className="far fa-circle nav-icon"/>
                            <p>Order</p></a>
                    return value;
                }
                if (value.object_name == "order_change_date" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    order_change_date =
                        <a href={myconfig.urlorder_change_date} className={this.state.order_change_date}><i
                            className="far fa-circle nav-icon"/>
                            <p>Change Date</p></a>
                    return value;
                }
                if (value.object_name == "order_change_cargo" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    order_change_cargo =
                        <a href={myconfig.urlorder_change_cargo} className={this.state.order_change_cargo}><i
                            className="far fa-circle nav-icon"/>
                            <p>Change Cargo</p></a>
                    return value;
                }
                if (value.object_name == "order_change_volume" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    order_change_volume =
                        <a href={myconfig.urlorder_change_volume} className={this.state.order_change_volume}><i
                            className="far fa-circle nav-icon"/>
                            <p>Change Volume</p></a>
                    return value;
                }
                if (value.object_name == "order_change_sale_type" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    order_change_sale_type =
                        <a href={myconfig.urlorder_change_sale_type} className={this.state.order_change_sale_type}><i
                            className="far fa-circle nav-icon"/>
                            <p>Change Sale Type</p></a>
                    return value;
                }
            })
            if (ordermgt.length > 0) {
                ordermenu = <li name="ordermgt" onClick={(event => {
                    this.menuclick(event, this.state.ordermgt)
                })} className={this.state.ordermgt}>
                    <a name="ordermgt" onClick={(event => {
                        this.menuclick(event, this.state.ordermgt)
                    })} href="#" className={this.state.ordermgt1}>
                        <i className="nav-icon fas fa-cart-arrow-down"/>
                        <p>
                            Sale Management
                            <i className="right fas fa-angle-left"/>
                        </p>
                    </a>
                    <ul className="nav nav-treeview">
                        <li className="nav-item">
                            {order}
                            {order_change_date}
                            {order_change_cargo}
                            {order_change_volume}
                            {order_change_sale_type}
                        </li>
                    </ul>
                </li>
            }

            let allocate_allocate_vehicle = "";
            let allocate_allocate_vehicle_v2 = "";
            let allocate_cost_mgt_v2 = "";
            let allocate_cost_approve_v2 = "";
            let allocate_cost_approve_v3 = "";
            let allocate_allocate_vehicle_v3 = "";
            let allocate_unallocate_vehicle = "";
            let allocate_date = "";
            let allocate_cost_manage = "";
            let allocate_cost_approval = "";
            let allocate_cost_report = "";
            let allocate_weight = "";
            let allocate_unload = "";
            let allocate_change_route = "";
            let allocate_finance = "";
            let allocatemenu = "";
            let allocatemgt = this.state.matrix.filter(value => {
                if (value.object_name == "allocate_allocate_vehicle" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_allocate_vehicle =
                        <a href={myconfig.urlallocate_allocate_vehicle}
                           className={this.state.allocate_allocate_vehicle}><i className="far fa-circle nav-icon"/>
                            <p>Allocate Truck</p></a>
                    return value;
                }
                if (value.object_name == "allocate_allocate_vehicle_v2" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_allocate_vehicle_v2 =
                        <a href={myconfig.urlallocate_allocate_vehicle_v2}
                           className={this.state.allocate_allocate_vehicle_v2}><i className="far fa-circle nav-icon"/>
                            <p>Allocate Truck (v2)</p></a>
                    return value;
                }
                if (value.object_name == "allocate_cost_mgt_v2" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_cost_mgt_v2 =
                        <a href={myconfig.urlallocate_cost_mgt_v2}
                           className={this.state.allocate_cost_mgt_v2}><i className="far fa-circle nav-icon"/>
                            <p>Cost Mgt (v2)</p></a>
                    return value;
                }
                if (value.object_name == "allocate_cost_approve_v2" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_cost_approve_v2 =
                        <a href={myconfig.urlallocate_cost_approve_v2}
                           className={this.state.allocate_cost_approve_v2}><i className="far fa-circle nav-icon"/>
                            <p>Cost Approve (v2)</p></a>
                    return value;
                }
                if (value.object_name == "allocate_cost_approve_v3" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_cost_approve_v3 =
                        <a href={myconfig.urlallocate_cost_approve_v3}
                           className={this.state.allocate_cost_approve_v3}><i className="far fa-circle nav-icon"/>
                            <p>Cost Approve (v3)</p></a>
                    return value;
                }
                if (value.object_name == "allocate_allocate_vehicle_v3" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_allocate_vehicle_v3 =
                        <a href={myconfig.urlallocate_allocate_vehicle_v3}
                           className={this.state.allocate_allocate_vehicle_v3}><i className="far fa-circle nav-icon"/>
                            <p>Allocate Vehicle (v3)</p></a>
                    return value;
                }
                if (value.object_name == "allocate_unallocate_vehicle" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_unallocate_vehicle =
                        <a href={myconfig.urlallocate_unallocate_vehicle}
                           className={this.state.allocate_unallocate_vehicle}><i className="far fa-circle nav-icon"/>
                            <p>Un-allocate Truck</p></a>
                    return value;
                }
                if (value.object_name == "allocate_date" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_date =
                        <a href={myconfig.urlallocate_date} className={this.state.allocate_date}><i
                            className="far fa-circle nav-icon"/>
                            <p>Date Management</p></a>
                    return value;
                }
                if (value.object_name == "allocate_cost_manage" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_cost_manage =
                        <a href={myconfig.urlallocate_cost_manage} className={this.state.allocate_cost_manage}><i
                            className="far fa-circle nav-icon"/>
                            <p>Cost Management</p></a>
                    return value;
                }
                if (value.object_name == "allocate_cost_approval" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_cost_approval =
                        <a href={myconfig.urlallocate_cost_approval} className={this.state.allocate_cost_approval}><i
                            className="far fa-circle nav-icon"/>
                            <p>Cost Approval</p></a>
                    return value;
                }
                if (value.object_name == "allocate_cost_report" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_cost_report =
                        <a href={myconfig.urlallocate_cost_report} className={this.state.allocate_cost_report}><i
                            className="far fa-circle nav-icon"/>
                            <p>Cost Report</p></a>
                    return value;
                }
                if (value.object_name == "allocate_weight" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_weight =
                        <a href={myconfig.urlallocate_weight} className={this.state.allocate_weight}><i
                            className="far fa-circle nav-icon"/>
                            <p>Weight Management</p></a>
                    return value;
                }
                if (value.object_name == "allocate_unload" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_unload =
                        <a href={myconfig.urlallocate_unload} className={this.state.allocate_unload}><i
                            className="far fa-circle nav-icon"/>
                            <p>Unload Management</p></a>
                    return value;
                }
                if (value.object_name == "allocate_change_route" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_change_route =
                        <a href={myconfig.urlallocate_change_route} className={this.state.allocate_change_route}><i
                            className="far fa-circle nav-icon"/>
                            <p>Change Route</p></a>
                    return value;
                }
                if (value.object_name == "allocate_finance" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_finance =
                        <a href={myconfig.urlallocate_finance} className={this.state.allocate_finance}><i
                            className="far fa-circle nav-icon"/>
                            <p>Finance</p></a>
                    return value;
                }
            })
            if (allocatemgt.length > 0) {
                allocatemenu = <li name="allocatemgt" onClick={(event => {
                    this.menuclick(event, this.state.allocatemgt)
                })} className={this.state.allocatemgt}>
                    <a name="allocatemgt" onClick={(event => {
                        this.menuclick(event, this.state.allocatemgt)
                    })} href="#" className={this.state.allocatemgt1}>
                        <i className="nav-icon fas fa-book"/>
                        <p>
                            Allocate Management
                            <i className="right fas fa-angle-left"/>
                        </p>
                    </a>
                    <ul className="nav nav-treeview">
                        <li className="nav-item">
                            {allocate_allocate_vehicle}
                            {allocate_allocate_vehicle_v2}
                            {allocate_cost_mgt_v2}
                            {allocate_cost_approve_v2}
                            {allocate_cost_approve_v3}
                            {allocate_allocate_vehicle_v3}
                            {allocate_unallocate_vehicle}
                            {allocate_date}
                            {allocate_cost_manage}
                            {allocate_cost_approval}
                            {allocate_cost_report}
                            {allocate_weight}
                            {allocate_unload}
                            {allocate_change_route}
                            {allocate_finance}
                        </li>
                    </ul>
                </li>
            }


            let allocate_extend_trip_req = "";
            let allocate_extend_trip_approval = "";
            let allocate_extend_trip_report = "";
            let allocateextendmenu = "";
            let allocateextendmgt = this.state.matrix.filter(value => {
                if (value.object_name == "allocate_extend_trip_req" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_extend_trip_req =
                        <a href={myconfig.urlallocate_extend_trip_req}
                           className={this.state.allocate_extend_trip_req}><i className="far fa-circle nav-icon"/>
                            <p>Extender Request</p></a>
                    return value;
                }
                if (value.object_name == "allocate_extend_trip_approval" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_extend_trip_approval =
                        <a href={myconfig.urlallocate_extend_trip_approval}
                           className={this.state.allocate_extend_trip_approval}><i className="far fa-circle nav-icon"/>
                            <p>Extender Approval</p></a>
                    return value;
                }
                if (value.object_name == "allocate_extend_trip_report" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocate_extend_trip_report =
                        <a href={myconfig.urlallocate_extend_trip_report}
                           className={this.state.allocate_extend_trip_report}><i className="far fa-circle nav-icon"/>
                            <p>Extender Report</p></a>
                    return value;
                }
            })
            if (allocateextendmgt.length > 0) {
                allocateextendmenu = <li name="allocateextendmgt" onClick={(event => {
                    this.menuclick(event, this.state.allocateextendmgt)
                })} className={this.state.allocateextendmgt}>
                    <a name="allocateextendmgt" onClick={(event => {
                        this.menuclick(event, this.state.allocateextendmgt)
                    })} href="#" className={this.state.allocateextendmgt1}>
                        <i className="nav-icon fas fa-arrow-alt-circle-down"/>
                        <p>
                            Trip Extender
                            <i className="right fas fa-angle-left"/>
                        </p>
                    </a>
                    <ul className="nav nav-treeview">
                        <li className="nav-item">
                            {allocate_extend_trip_req}
                            {allocate_extend_trip_approval}
                            {allocate_extend_trip_report}
                        </li>
                    </ul>
                </li>
            }

            let admin_transport = "";
            let admin_vehicle = "";
            let admin_driver = "";
            let admin_trailer = "";
            let admin_assignement = "";
            let admin_location = "";
            let admin_road_route = "";
            let admin_cargo = "";
            let admin_status = "";
            let adminmenu = "";
            let adminmenumgt = this.state.matrix.filter(value => {
                if (value.object_name == "admin_transport" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    admin_transport =
                        <a href={myconfig.urladmin_transport} className={this.state.admin_transport}><i
                            className="far fa-circle nav-icon"/>
                            <p>Transporter</p></a>
                    return value;
                }
                if (value.object_name == "admin_vehicle" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    admin_vehicle =
                        <a href={myconfig.urladmin_vehicle} className={this.state.admin_vehicle}><i
                            className="far fa-circle nav-icon"/>
                            <p>Vehicle</p></a>
                    return value;
                }
                if (value.object_name == "admin_driver" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    admin_driver =
                        <a href={myconfig.urladmin_driver} className={this.state.admin_driver}><i
                            className="far fa-circle nav-icon"/>
                            <p>Driver</p></a>
                    return value;
                }
                if (value.object_name == "admin_trailer" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    admin_trailer =
                        <a href={myconfig.urladmin_trailer} className={this.state.admin_trailer}><i
                            className="far fa-circle nav-icon"/>
                            <p>Trailer</p></a>
                    return value;
                }
                if (value.object_name == "admin_assignement" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    admin_assignement =
                        <a href={myconfig.urladmin_assignement} className={this.state.admin_assignement}><i
                            className="far fa-circle nav-icon"/>
                            <p>Assignment</p></a>
                    return value;
                }
                if (value.object_name == "admin_location" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    admin_location =
                        <a href={myconfig.urladmin_location} className={this.state.admin_location}><i
                            className="far fa-circle nav-icon"/>
                            <p>Location</p></a>
                    return value;
                }
                if (value.object_name == "admin_road_route" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    admin_road_route =
                        <a href={myconfig.urladmin_road_route} className={this.state.admin_road_route}><i
                            className="far fa-circle nav-icon"/>
                            <p>Road-route</p></a>
                    return value;
                }
                if (value.object_name == "admin_cargo" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    admin_cargo =
                        <a href={myconfig.urladmin_cargo} className={this.state.admin_cargo}><i
                            className="far fa-circle nav-icon"/>
                            <p>Cargo's</p></a>
                    return value;
                }
                if (value.object_name == "admin_status" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    admin_status =
                        <a href={myconfig.urladmin_status} className={this.state.admin_status}><i
                            className="far fa-circle nav-icon"/>
                            <p>Status</p></a>
                    return value;
                }
            })
            if (adminmenumgt.length > 0) {
                adminmenu = <li name="adminmenumgt" onClick={(event => {
                    this.menuclick(event, this.state.adminmenumgt)
                })} className={this.state.adminmenumgt}>
                    <a name="adminmenumgt" onClick={(event => {
                        this.menuclick(event, this.state.adminmenumgt)
                    })} href="#" className={this.state.adminmenumgt1}>
                        <i className="nav-icon fas fa-passport"/>
                        <p>
                            Admin
                            <i className="right fas fa-angle-left"/>
                        </p>
                    </a>
                    <ul className="nav nav-treeview">
                        <li className="nav-item">
                            {admin_transport}
                            {admin_vehicle}
                            {admin_driver}
                            {admin_trailer}
                            {admin_assignement}
                            {admin_location}
                            {admin_road_route}
                            {admin_cargo}
                            {admin_status}
                        </li>
                    </ul>
                </li>
            }

            let follow_up_allocated_veh = "";
            let follow_up_to_load_veh = "";
            let follow_up_load_veh = "";
            let follow_up_departure_veh = "";
            let follow_up_to_unload_veh = "";
            let follow_up_unload_veh = "";
            let follow_up_status = "";
            let follow_up_status_v2 = "";
            let follow_up_finish = "";
            let follow_up_v2 = "";
            let follow_up_contoral = "";
            let followmenu = "";
            let followupmenumgt = this.state.matrix.filter(value => {
                if (value.object_name == "follow_up_allocated_veh" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_allocated_veh =
                        <a href={myconfig.urlfollow_up_allocated_veh} className={this.state.follow_up_allocated_veh}><i
                            className="far fa-circle nav-icon"/>
                            <p>Allocate</p></a>
                    return value;
                }
                if (value.object_name == "follow_up_to_load_veh" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_to_load_veh =
                        <a href={myconfig.urlfollow_up_to_load_veh} className={this.state.follow_up_to_load_veh}><i
                            className="far fa-circle nav-icon"/>
                            <p>To Load</p></a>
                    return value;
                }
                if (value.object_name == "follow_up_load_veh" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_load_veh =
                        <a href={myconfig.urlfollow_up_load_veh} className={this.state.follow_up_load_veh}><i
                            className="far fa-circle nav-icon"/>
                            <p>Loading</p></a>
                    return value;
                }
                if (value.object_name == "follow_up_departure_veh" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_departure_veh =
                        <a href={myconfig.urlfollow_up_departure_veh} className={this.state.follow_up_departure_veh}><i
                            className="far fa-circle nav-icon"/>
                            <p>Departure</p></a>
                    return value;
                }
                if (value.object_name == "follow_up_to_unload_veh" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_to_unload_veh =
                        <a href={myconfig.urlfollow_up_to_unload_veh} className={this.state.follow_up_to_unload_veh}><i
                            className="far fa-circle nav-icon"/>
                            <p>To Unload</p></a>
                    return value;
                }
                if (value.object_name == "follow_up_unload_veh" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_unload_veh =
                        <a href={myconfig.urlfollow_up_unload_veh} className={this.state.follow_up_unload_veh}><i
                            className="far fa-circle nav-icon"/>
                            <p>Unloading</p></a>
                    return value;
                }
                if (value.object_name == "follow_up_status" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_status =
                        <a href={myconfig.urlfollow_up_status} className={this.state.follow_up_status}><i
                            className="far fa-circle nav-icon"/>
                            <p>Status</p></a>
                    return value;
                }
                if (value.object_name == "follow_up_status_v2" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_status_v2 =
                        <a href={myconfig.urlfollow_up_status_v2} className={this.state.follow_up_status_v2}><i
                            className="far fa-circle nav-icon"/>
                            <p>Status (v2)</p></a>
                    return value;
                }
                if (value.object_name == "follow_up_finish" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_finish =
                        <a href={myconfig.urlfollow_up_finish} className={this.state.follow_up_finish}><i
                            className="far fa-circle nav-icon"/>
                            <p>Finished</p></a>
                    return value;
                }
                if (value.object_name == "follow_up_v2" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_v2 =
                        <a href={myconfig.urlfollow_up_v2} className={this.state.follow_up_v2}><i
                            className="far fa-circle nav-icon"/>
                            <p>Follow_up (v2)</p></a>
                    return value;
                }
                if (value.object_name == "follow_up_contoral" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    follow_up_contoral =
                        <a href={myconfig.urlfollow_up_contoral} className={this.state.follow_up_contoral}><i
                            className="far fa-circle nav-icon"/>
                            <p>Controller</p></a>
                    return value;
                }
            })
            if (followupmenumgt.length > 0) {
                followmenu = <li name="followupmenumgt" onClick={(event => {
                    this.menuclick(event, this.state.followupmenumgt)
                })} className={this.state.followupmenumgt}>
                    <a name="followupmenumgt" onClick={(event => {
                        this.menuclick(event, this.state.followupmenumgt)
                    })} href="#" className={this.state.followupmenumgt1}>
                        <i className="nav-icon fas fa-search"/>
                        <p>
                            Follow-Up
                            <i className="right fas fa-angle-left"/>
                        </p>
                    </a>
                    <ul className="nav nav-treeview">
                        <li className="nav-item">
                            {follow_up_allocated_veh}
                            {follow_up_to_load_veh}
                            {follow_up_load_veh}
                            {follow_up_departure_veh}
                            {follow_up_to_unload_veh}
                            {follow_up_unload_veh}
                            {follow_up_status}
                            {follow_up_status_v2}
                            {follow_up_finish}
                            {follow_up_v2}
                            {follow_up_contoral}
                        </li>
                    </ul>
                </li>
            }


            let open_order_status = "";
            let close_order_status = "";
            let allocation_status = "";
            let movement_status = "";
            let orderstatusmenu = "";
            let orderstatusmgt = this.state.matrix.filter(value => {
                if (value.object_name == "open_order_status" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    open_order_status =
                        <a href={myconfig.urlopen_order_status} className={this.state.open_order_status}><i
                            className="far fa-circle nav-icon"/>
                            <p>Open Order</p></a>
                    return value;
                }
                if (value.object_name == "close_order_status" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    close_order_status =
                        <a href={myconfig.urlclose_order_status} className={this.state.close_order_status}><i
                            className="far fa-circle nav-icon"/>
                            <p>Closed Order</p></a>
                    return value;
                }
                if (value.object_name == "allocation_status" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    allocation_status =
                        <a href={myconfig.urlallocation_status} className={this.state.allocation_status}><i
                            className="far fa-circle nav-icon"/>
                            <p>Allocation</p></a>
                    return value;
                }
                if (value.object_name == "movement_status" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    movement_status =
                        <a href={myconfig.urlmovement_status} className={this.state.movement_status}><i
                            className="far fa-circle nav-icon"/>
                            <p>Movement</p></a>
                    return value;
                }
            })
            if (orderstatusmgt.length > 0) {
                orderstatusmenu = <li name="orderstatusmgt" onClick={(event => {
                    this.menuclick(event, this.state.orderstatusmgt)
                })} className={this.state.orderstatusmgt}>
                    <a name="orderstatusmgt" onClick={(event => {
                        this.menuclick(event, this.state.orderstatusmgt)
                    })} href="#" className={this.state.orderstatusmgt1}>
                        <i className="nav-icon fas fa-newspaper"/>
                        <p>
                            Status
                            <i className="right fas fa-angle-left"/>
                        </p>
                    </a>
                    <ul className="nav nav-treeview">
                        <li className="nav-item">
                            {open_order_status}
                            {close_order_status}
                            {allocation_status}
                            {movement_status}
                        </li>
                    </ul>
                </li>
            }

            let rep_trip_master = "";
            let master_trip_2 = "";
            let screen_1 = "";
            let screen_2 = "";
            let customer_tracking = "";
            let rep_tracking_master = "";
            let rep_tac = "";
            let reportmenu="";
            let reportmgt = this.state.matrix.filter(value => {
                if (value.object_name == "rep_tracking_master" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    rep_tracking_master =
                        <a href={myconfig.urlrep_tracking_master} className={this.state.rep_tracking_master}><i
                            className="far fa-circle nav-icon"/>
                            <p>Tracking Master</p></a>
                    return value;
                }
                if (value.object_name == "rep_tac" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    rep_tac =
                        <a href={myconfig.urlrep_tac} className={this.state.rep_tac}><i
                            className="far fa-circle nav-icon"/>
                            <p>TAC Report</p></a>
                    return value;
                }
                if (value.object_name == "rep_trip_master" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    rep_trip_master =
                        <a href={myconfig.urlrep_trip_master} className={this.state.rep_trip_master}><i
                            className="far fa-circle nav-icon"/>
                            <p>Trip Master</p></a>
                    return value;
                }
                if (value.object_name == "master_trip_2" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    master_trip_2 =
                        <a href={myconfig.urlmaster_trip_2} className={this.state.master_trip_2}><i
                            className="far fa-circle nav-icon"/>
                            <p>Trip Master(v2)</p></a>
                    return value;
                }
                if (value.object_name == "screen_1" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    screen_1 =
                        <a target="_blank" href={myconfig.urlscreen_1} className={this.state.screen_1}><i
                            className="far fa-circle nav-icon"/>
                            <p>Screen-1</p></a>
                    return value;
                }
                if (value.object_name == "screen_2" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    screen_2 =
                        <a target="_blank" href={myconfig.urlscreen_2} className={this.state.screen_2}><i
                            className="far fa-circle nav-icon"/>
                            <p>Screen-2</p></a>
                    return value;
                }
                if (value.object_name == "customer_tracking" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    customer_tracking =
                        <a target="_blank" href={myconfig.urlcustomer_tracking} className={this.state.customer_tracking}><i
                            className="far fa-circle nav-icon"/>
                            <p>Customer Tracking</p></a>
                    return value;
                }
            })
            if (reportmgt.length > 0) {
                reportmenu = <li name="reportmgt" onClick={(event => {
                    this.menuclick(event, this.state.reportmgt)
                })} className={this.state.reportmgt}>
                    <a name="reportmgt" onClick={(event => {
                        this.menuclick(event, this.state.reportmgt)
                    })} href="#" className={this.state.reportmgt1}>
                        <i className="nav-icon fas fa-book-open"/>
                        <p>
                            Report
                            <i className="right fas fa-angle-left"/>
                        </p>
                    </a>
                    <ul className="nav nav-treeview">
                        <li className="nav-item">
                            {rep_tracking_master}
                            {rep_trip_master}
                            {rep_tac}
                            {master_trip_2}
                            {screen_1}
                            {screen_2}
                            {customer_tracking}
                        </li>
                    </ul>
                </li>
            }

            let driver_point_by_trip = "";
            let driver_point_by_vio = "";
            let driver_pointmenu="";
            let driver_pointmgt = this.state.matrix.filter(value => {
                if (value.object_name == "driver_point_by_trip" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    driver_point_by_trip =
                        <a href={myconfig.urldriver_point_by_trip} className={this.state.driver_point_by_trip}><i
                            className="far fa-circle nav-icon"/>
                            <p>By Trip</p></a>
                    return value;
                }
                if (value.object_name == "driver_point_by_vio" &&
                    (value.create || value.update || value.read || value.delete)
                ) {
                    driver_point_by_vio =
                        <a href={myconfig.urldriver_point_by_vio} className={this.state.driver_point_by_vio}><i
                            className="far fa-circle nav-icon"/>
                            <p>By Violation</p></a>
                    return value;
                }
            })
            if (driver_pointmgt.length > 0) {
                driver_pointmenu = <li name="driver_pointmgt" onClick={(event => {
                    this.menuclick(event, this.state.driver_pointmgt)
                })} className={this.state.driver_pointmgt}>
                    <a name="driver_pointmgt" onClick={(event => {
                        this.menuclick(event, this.state.driver_pointmgt)
                    })} href="#" className={this.state.driver_pointmgt1}>
                        <i className="nav-icon fas fa-star"/>
                        <p>
                            Driver Performance
                            <i className="right fas fa-angle-left"/>
                        </p>
                    </a>
                    <ul className="nav nav-treeview">
                        <li className="nav-item">
                            {driver_point_by_trip}
                            {driver_point_by_vio}
                        </li>
                    </ul>
                </li>
            }

            return <>
                {dashboardmenu}
                {adminmenu}
                {usermenu}
                {ordermenu}
                {allocatemenu}
                {allocateextendmenu}
                {followmenu}
                {orderstatusmenu}
                {reportmenu}
                {driver_pointmenu}
            </>
        } else {
            return (<>
                {}
            </>)
        }
    }
    menuclick = (event, value) => {
        var name = event.target.name;
        if (value == 'nav-item')
            value = 'nav-item menu-open active';
        else
            value = 'nav-item'
        this.setState({
            [name]: value,
        })
    }

    render() {
        return (
            <>
                <nav className="main-header navbar navbar-expand navbar-white navbar-light text-sm">
                    {/* Left navbar links */}
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i
                                className="fas fa-bars"/></a>
                        </li>
                        <li className="nav-item d-none d-sm-inline-block">
                            <a href="index3.html" className="nav-link">Home</a>
                        </li>
                        <li className="nav-item d-none d-sm-inline-block">
                            <a href="#" className="nav-link">Contact</a>
                        </li>
                    </ul>
                    {/* Right navbar links */}
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <a className="nav-link" data-widget="fullscreen" href="" onClick={this.logout}
                               role="button">
                                <i className="fas fa-sign-out-alt"/>
                            </a>
                        </li>
                    </ul>
                </nav>
                <aside className="main-sidebar sidebar-dark-primary elevation-4">
                    <a href="#" className="brand-link text-sm">
                        <img src={logimg} alt="AdminLTE Logo" className="brand-image img-circle elevation-5"
                             style={{opacity: '.8'}}/>
                        <span className="brand-text font-weight-light">NT FMS</span>
                    </a>
                    {/* Sidebar */}
                    <div className="sidebar">
                        {/* Sidebar user panel (optional) */}
                        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                            <div className="image">
                            </div>
                            <div className="info">
                                <a href="#" className="d-block">National Transport</a>
                            </div>
                        </div>
                        <nav className="mt-2">
                            <ul className="nav nav-pills nav-sidebar flex-column text-sm" data-widget="treeview"
                                role="menu" data-accordion="false">
                                {this.displaymenus()}
                            </ul>
                        </nav>
                        {/* /.sidebar-menu */}
                    </div>
                    {/* /.sidebar */}
                </aside>
            </>
        );
    }
}
export default Nav;
